import { useCallback, useEffect, useState } from "react";
import {
  Row,
  Tooltip,
  Col,
  Image,
  Button,
  Input,
  Divider,
  Select,
  Card,
  Space,
  Switch,
  Spin,
  Modal,
  Form,
  Checkbox,
  Pagination,
  DatePicker,
  Badge,
  Popover,
  Typography,
  Table,
} from "../../../../components/common/utils/antd-imports/AntdImports.js";
import { ReactComponent as BackArrow } from "../../../../assests/back-arrow.svg";
import DimensionsIcon from "../../../../assests/dimensions_icon.svg";
import GraphIcon from "../../../../assests/graph_icon.svg";
import { ReactComponent as DocumentIcon } from "../../../../assests/doc-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assests/edit-icon.svg";
import FolderIcon from "../../../../assests/folder-icon.svg";
import DigitalBoard from "../../../../assests/digital-billboard.svg";
import { ReactComponent as EyeIcon } from "../../../../assests/eye-icon.svg";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "./MyBillboard.css";
import "../../../../main.css";
import { useDispatch, useSelector } from "react-redux";
import AddBillBoard from "../../../../components/common/bill-board/AddBillboard.js";
import EmptyViewCard from "../../../../components/common/empty-view-card/EmptyViewCard.js";
import {
  getOwnerProducts,
  productVisibility,
} from "../../../../store/thunks/seller-thunks/SellerThunk.js";
import {
  RESET_PRODUCT,
  RESET_PRODUCTS,
} from "../../../../store/slices/common-slice/products/ProductSlice.js";
import ProductModalPopUp from "../../../../components/modal/product-detail-modal/ProductModalPopUp.js";
import Arrow3 from "../../../../assests/Arrow 3.svg";
import { API_BASE_URL_IMAGE } from "../../../../services/common.js";
import BulkUploadModal from "../../modals/bulk-upload/BulkUploadModal.js";
import FeaturedCampaignsModal from "../../modals/featured-campaigns/FeaturedCampaignsModal.js";
import { ReactComponent as CalenderIcon } from "../../../../assests/Billboard_Calender_Icon.svg";
import enUS from "antd/es/date-picker/locale/en_US";
import {
  formatDateWithTimestamp,
  handleCopy,
} from "../../../../components/common/utils/Utils.js";
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EllipsisOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { ReactComponent as SearchIcon } from "../../../../assests/search-icon.svg";
import { ReactComponent as SelectUpIcon } from "../../../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../../../../assests/select-down-icon.svg";
import { formatToUSCurrency } from "../../../../components/common/utils/Utils.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import TransferProducts from "../../../../components/modal/transfer-products-model/TransferProducts.js";
import BreadcrumbNav from "../../../../components/common/bread-crumbs/BreadCrumb.js";
import { setIsProductPopUp } from "../../../../store/slices/common-slice/product-details-action-items/productDetailsActionItemslice.js";
dayjs.extend(utc);
const { Text } = Typography;

const MyBillboard = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 769 });
  const [form] = Form.useForm();
  const [isCloneProduct, setIsCloneProduct] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openTransferDialog, setTransferDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [billBoardText, setBillboardText] = useState("");
  const [isAvailable, setIsAvailable] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [mobileOpenDialog, setMobileOpenDialog] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [bulkUpload, setBulkUpload] = useState("");
  const [selectedType, setSelectedType] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [productDetails, setProductDetails] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { userGuidlineAcceptance } = useSelector((state) => state.userprofile);

  const { user } = useSelector((state) => {
    const userProfile = state.userprofile;
    return {
      ...userProfile,
      userType:
        userProfile.userType === "basic" ? "Buyer" : userProfile.userType,
    };
  });
  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  const {
    isLoading: sellerCampainsLoader,
    products,
    page_count,
  } = useSelector((state) => state.sellerCampaigns);
  const { isLoading: productsLoader } = useSelector((state) => state.products);
  const [records, setRecords] = useState(products);

  const dispatch = useDispatch();
  const getFromDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(parseInt(timestamp, 10));
    if (isNaN(date.getTime())) {
      return "";
    }
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };
  const bulkUploadFiles = () => {
    setBulkUpload(true);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSwitch = (checked, product) => {
    let showOnMap = checked ? 1 : 0;
    dispatch(
      productVisibility({
        productId: product.id,
        product_visibility: showOnMap,
      }),
    ).then(() => {
      refreshContentProducts();
    });
  };
  const handleFeaturedCampaignModal = (product) => {
    if (product.camapigns_count <= 0) return;
    setProductDetails(product);
    setIsModalOpen(true);
  };
  const refreshContentProducts = useCallback(() => {
    let payload = {
      budget: "",
      dma: "",
      format: selectedType === "" ? "" : { name: selectedType },
      page_no: !searchText ? currentPage : 1,
      page_size: itemsPerPage,
      product_name: searchText,
      show_available: isAvailable,
      ...(startDate && {
        start_date: startDate,
      }),
      ...(endDate && {
        end_date: endDate,
      }),
    };
    dispatch(getOwnerProducts(payload));
  }, [isAvailable, startDate, endDate, searchText, currentPage, selectedType]);

  useEffect(() => {
    if (!searchText) {
      refreshContentProducts();
    }

    dispatch(RESET_PRODUCTS());
    const delayDebounce = setTimeout(() => {
      if (searchText) {
        setCurrentPage(1);
        refreshContentProducts();
      }
    }, 400);

    return () => {
      clearTimeout(delayDebounce);
    };
  }, [searchText]);

  useEffect(() => {
    refreshContentProducts();
  }, [isAvailable, startDate, endDate, selectedType, currentPage]);

  const productActions = (
    <div className="align-flex">
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          setMobileOpenDialog(true);
          setPopoverOpen(false);
          setBillboardText("Add New Product");
        }}
      >
        Add New Product
      </Button>
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          setPopoverOpen(false);
          setBulkUpload(true);
        }}
      >
        Bulk Upload Products
      </Button>
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          setPopoverOpen(false);
          setTransferDialog(true);
        }}
      >
        Transfer Products
      </Button>
    </div>
  );

  const billboardActions = (
    <div className="align-flex">
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          navigate("/seller/viewproduct", {
            state: { product: selectedProduct, isBillboard: true },
          });
        }}
      >
        <EyeIcon className="myBillboard-icons" />
        View
      </Button>
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          setMobileOpenDialog(true);
          setBillboardText("Edit Product Details");
        }}
      >
        <EditIcon className="myBillboard-icons" />
        Edit
      </Button>
      <Button
        className="action-btns"
        type="text"
        onClick={() => {
          setSelectedProduct(selectedProduct);
          setMobileOpenDialog(true);
          setBillboardText("Duplicate Product Details");
          setIsCloneProduct(true);
        }}
      >
        <DocumentIcon className="myBillboard-icons" />
        Duplicate
      </Button>
    </div>
  );

  const handleProductActions = (visible) => {
    setPopoverOpen((visible) => !visible);
  };

  //update records after getting api response
  useEffect(() => {
    if (products) {
      setRecords(products);
    }
  }, [products]);

  const formatSize = (value) => {
    if (!value) return "";
    return value
      .replace(" feet", "'") // Convert feet to '
      .replace("LineInches", '"') // Convert inches to "
      .replace(" pixels", " px"); // Convert pixels to px
  };

  const truncatedText = (formattedText) => {
    return formattedText.length > 7
      ? formattedText.slice(0, 6) + "..."
      : formattedText;
  };

  useEffect(() => {
    if (isMobile) {
      setOpenDialog(false);
    } else {
      setMobileOpenDialog(false);
    }
  }, [isMobile, setOpenDialog]);

  // converting the dates
  const getDateValues = (dateField) => {
    if (Array?.isArray(dateField)) {
      return dateField;
    }

    return dateField ? [dateField] : [];
  };

  const getTableColumns = (product) => [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];

  return (
    <>
      {!mobileOpenDialog && (
        <div className="common-container">
          <>
            <Row className="my-products-header" justify="space-between">
              <Col span={isMobile ? 24 : 12}>
                <div>
                  <BreadcrumbNav />
                </div>
                <h1 className="campaign  my-product">
                  <div
                    className="my-billboard-campaign-div"
                    style={{
                      alignItems: "center",
                    }}
                  >
                    {!isMobile && (
                      <BackArrow
                        className="arrow-align"
                        onClick={() => navigate(-1)}
                      />
                    )}
                    <span
                      style={{
                        fontFamily: "Roboto",
                        fontSize: isMobile ? "16px" : "19px",
                      }}
                    >
                      My Products
                    </span>
                  </div>
                </h1>
              </Col>
              <Col className="billboard-search " span={isMobile ? 20 : 12}>
                <Input
                  prefix={<SearchIcon />}
                  className="view-campaign-search common-search"
                  value={searchText}
                  allowClear
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search by product name..."
                />
              </Col>
            </Row>

            <Row className="billBoard-actions">
              {!isMobile && (
                <Col
                  sm={24}
                  md={12}
                  lg={24}
                  xl={12}
                  className="my-billboard-campaign-col"
                  style={{
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="set-buttons">
                    <Button
                      className="transfer-btn product-actions"
                      onClick={() => setTransferDialog(true)}
                    >
                      Transfer Products
                    </Button>
                  </div>
                  <div className="set-buttons">
                    <Button
                      className="bulk-upload-btn product-actions"
                      onClick={bulkUploadFiles}
                    >
                      Bulk Upload Products
                    </Button>
                  </div>
                  <div className="set-buttons">
                    <Button
                      className="add-new-btn product-actions"
                      onClick={() => {
                        setOpenDialog(true);
                        setBillboardText("Add New Product");
                      }}
                    >
                      Add New Product
                    </Button>
                  </div>
                </Col>
              )}
            </Row>
            <Row className="filter-billBoards">
              <Col>
                <div className="billboard-filter">
                  <span className="filter-text">Filter </span>:
                  <Select
                    className="select-type"
                    popupClassName="select-type-drop-down"
                    value={selectedType}
                    onDropdownVisibleChange={(open) => setIsOpen(open)}
                    suffixIcon={isOpen ? <SelectUpIcon /> : <SelectDownIcon />}
                    onChange={(value) => {
                      setSelectedType(value);
                      setCurrentPage(1);
                    }}
                    options={[
                      { value: "All", label: "All" },
                      { value: "Static", label: "Static" },
                      { value: "Digital", label: "Digital" },
                      {
                        value: "Digital/Static",
                        label: "Digital/Static",
                      },
                      { value: "Media", label: "Media" },
                    ]}
                  />
                </div>
              </Col>
              {!isMobile && (
                <Divider className="vertical-divider" type="vertical" />
              )}
              <Col className="billboard-filter">
                <Checkbox
                  checked={isAvailable}
                  className={`available-check ${!isMobile} ? "billboard-filter" : ""`}
                  onChange={(event) => {
                    setIsAvailable(event.target.checked);
                    setCurrentPage(1);
                  }}
                />
                <span className="isAvailable">Show Only Available</span>
              </Col>
              {!isMobile && (
                <Divider className="vertical-divider" type="vertical" />
              )}
              <div style={{ display: "flex" }}>
                <Col>
                  <div className="datepickers">
                    <DatePicker
                      value={startDate ? dayjs(startDate) : null}
                      name="startDate"
                      locale={customLocale}
                      onChange={(date, dateString) => {
                        dateString
                          ? setStartDate(
                              dayjs
                                ?.utc(dateString, "YYYY-MM-DD")
                                ?.startOf("day")
                                ?.toISOString(),
                            )
                          : setStartDate("");
                        setCurrentPage(1);
                      }}
                      className="my-billboard-datepicker"
                      popupClassName="my-billboard-datepicker-dropdown"
                      placeholder="Available from"
                      suffixIcon={<CalenderIcon />}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    />
                  </div>
                </Col>
                <Col className="endDatePicker">
                  <div className="datepickers">
                    <DatePicker
                      value={endDate ? dayjs(endDate) : null}
                      name="endDate"
                      locale={customLocale}
                      className="my-billboard-datepicker"
                      popupClassName="my-billboard-datepicker-dropdown"
                      onChange={(date, dateString) => {
                        dateString
                          ? setEndDate(
                              dayjs
                                ?.utc(dateString, "YYYY-MM-DD")
                                ?.startOf("day")
                                ?.toISOString(),
                            )
                          : setEndDate("");
                        setCurrentPage(1);
                      }}
                      placeholder="Available To"
                      suffixIcon={<CalenderIcon />}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    />
                  </div>
                </Col>
              </div>
              <Col
                className="billboard-clear-all"
                onClick={() => {
                  setSelectedType("All");
                  setCurrentPage(1);
                  setSearchText("");
                  setIsAvailable(false);
                  setStartDate("");
                  setEndDate("");
                }}
              >
                <span>Clear All</span>
              </Col>
            </Row>

            {isMobile ? (
              <>
                {records?.length > 0 ? (
                  records?.map((product, index) => {
                    const fromDates = getDateValues(product?.from_date);
                    const toDates = getDateValues(product?.to_date);
                    const quantity = product?.unitQty;
                    const tableData = fromDates?.map((from, idx) => ({
                      key: idx,
                      startDate: getFromDate(from?.$date?.$numberLong),
                      endDate: getFromDate(toDates?.[idx]?.$date?.$numberLong),
                      quantity: quantity?.[idx] ?? "-",
                    }));
                    const minFromDate =
                      fromDates?.length > 0
                        ? Math.min(
                            ...fromDates?.map((item) =>
                              Number(item?.$date?.$numberLong),
                            ),
                          )
                        : null;

                    const maxToDate =
                      toDates?.length > 0
                        ? Math.max(
                            ...toDates?.map((item) =>
                              Number(item?.$date?.$numberLong),
                            ),
                          )
                        : null;

                    const firstFromDate = minFromDate
                      ? getFromDate(minFromDate)
                      : "";

                    const firstToDate = maxToDate ? getFromDate(maxToDate) : "";
                    const slotsLength = Math.max(
                      fromDates?.length,
                      toDates?.length,
                    );
                    const dateContent = (
                      <>
                        {firstFromDate}
                        <Image
                          src={Arrow3}
                          className="siteName-image seller-multi-slot-arrow"
                          preview={false}
                        />
                        {firstToDate}
                      </>
                    );
                    const popoverContent = (
                      <div className="slots-popover">
                        <div
                          className="product-title"
                          style={{ marginBottom: "10px" }}
                        >
                          Available Slots
                        </div>
                        <Table
                          columns={getTableColumns(product)}
                          dataSource={tableData}
                          pagination={false}
                          rowKey="key"
                          size="small"
                          className="billboard-table"
                        />
                      </div>
                    );
                    return (
                      <div
                        className={
                          "billboard-container" +
                          (product.mandatory_missed_count > 0
                            ? " ribbon-margin"
                            : "")
                        }
                        key={product.siteNo}
                      >
                        {/* For the feature use }
                        {/* {product.mandatory_missed_count > 0 && (
                          <Badge.Ribbon
                            text="Action Needed : Complete Details"
                            color="#D2042D"
                          />
                        )} */}
                        <Card className="my-billboard-card">
                          <Row className="product-card ">
                            <Col
                              span={13}
                              className="featured"
                              onClick={() =>
                                handleFeaturedCampaignModal(product)
                              }
                            >
                              <Image
                                className="folder-icon"
                                src={FolderIcon}
                                preview={false}
                              />
                              <span className="default-color">
                                Featured in {product.camapigns_count} campaigns
                              </span>
                            </Col>
                            <Col span={10}>
                              <div style={{ display: "flex" }}>
                                <span className="map-label">Show on Map </span>
                                <Switch
                                  className="switch-map"
                                  checked={
                                    Number(product.product_visibility) === 1
                                  }
                                  onChange={(checked) =>
                                    handleSwitch(checked, product)
                                  }
                                />{" "}
                              </div>
                            </Col>
                          </Row>
                          <Row className="product-img-section" gutter={10}>
                            <Col span={10}>
                              <Image
                                className="product-img"
                                src={
                                  product?.image?.[0]
                                    ? product?.insert_type ===
                                      "Bulk_Apparatix_api"
                                      ? product.image[0]
                                      : `${API_BASE_URL_IMAGE}${product.image[0]}`
                                    : ""
                                }
                                preview={false}
                              />
                            </Col>
                            <Col span={14}>
                              <Row>
                                <div className="product-id">
                                  {product.siteNo}
                                </div>
                                <Tooltip
                                  styles={{
                                    body: {
                                      color: "#fff",
                                      backgroundColor: "#000",
                                    },
                                  }}
                                  title={
                                    <pre className="tooltip-product-card">
                                      {product?.title}
                                    </pre>
                                  }
                                >
                                  <Text
                                    className="product-title truncate"
                                    strong
                                  >
                                    {product?.title}
                                  </Text>
                                </Tooltip>
                              </Row>
                              <div className="dates" style={{ width: "100%" }}>
                                <div className="available-txt">
                                  Available from
                                </div>
                                <Row className="product-availability  product-availability-desk">
                                  <Tooltip title={dateContent}>
                                    <span>{dateContent}</span>
                                  </Tooltip>
                                  <Col
                                    span={24}
                                    className="product-labels siteNumber"
                                  >
                                    {slotsLength > 1 && (
                                      <Popover
                                        content={popoverContent}
                                        trigger="click"
                                        placement="bottom"
                                      >
                                        <span
                                          className="default-color"
                                          style={{
                                            fontFamily: "Roboto",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          View Slots
                                        </span>
                                      </Popover>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                          <Row className="address-section">
                            <Col span={14}>
                              <div className="product-labels"> Address</div>
                              <div className="product-details-value">
                                {product.address}{" "}
                              </div>
                            </Col>
                            <Col span={10}>
                              <div className="product-labels">
                                Facing Direction
                              </div>
                              <div className="product-details-value">
                                {product.direction}{" "}
                              </div>
                            </Col>
                          </Row>
                          <Row gutter={9} className="impressions-row">
                            <Col span={8} style={{ textAlign: "center" }}>
                              <Image
                                src={DimensionsIcon}
                                preview={false}
                                height={28}
                              />
                              <div className="billboard-details">
                                {formatSize(product?.width)} X{" "}
                                {formatSize(product?.height)}
                              </div>
                            </Col>
                            <Col span={8} style={{ textAlign: "center" }}>
                              <Image src={GraphIcon} preview={false} />
                              <div className="billboard-details">
                                {Number(
                                  product?.secondImpression,
                                ).toLocaleString()}{" "}
                                <span>+ per week</span>
                              </div>
                            </Col>
                            <Col span={8} style={{ textAlign: "center" }}>
                              <Image
                                src={DigitalBoard}
                                preview={false}
                                height={28}
                              />
                              <div className="billboard-details">
                                {product.type}
                              </div>
                            </Col>
                          </Row>
                          <Row className="price-actions">
                            <Col>
                              <span className="price-details">
                                $
                                {Number(product.default_price).toLocaleString()}
                              </span>
                              <span className="negotiable-text">
                                {" "}
                                Negotiable
                              </span>
                            </Col>
                            <Col>
                              <Popover
                                placement="top"
                                title=""
                                open={selectedProduct?.id === product.id}
                                content={billboardActions}
                                onOpenChange={(visible) => {
                                  if (!visible) {
                                    setSelectedProduct(null);
                                  }
                                }}
                              >
                                <Button
                                  className="billboard-action-button"
                                  shape="square"
                                  icon={<EllipsisOutlined />}
                                  size="large"
                                  onClick={() => {
                                    setSelectedProduct(product);
                                  }}
                                />
                              </Popover>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ width: "100%" }}>
                    <EmptyViewCard
                      header={"Products..."}
                      text={
                        "Looks like there aren't any products right now. But don't worry—add new product! Stay tuned and keep your listings"
                      }
                    />
                  </div>
                )}
                <div className="floating-icon">
                  <Popover
                    placement="top"
                    title=""
                    open={popoverOpen}
                    content={productActions}
                  >
                    <Button
                      className="custom-button"
                      shape="circle"
                      icon={popoverOpen ? <CloseOutlined /> : <PlusOutlined />}
                      size="large"
                      onClick={handleProductActions}
                    />
                  </Popover>
                </div>
              </>
            ) : (
              <Row
                style={{ justifyContent: "center" }}
                className="mobile-products-row"
              >
                {records?.length > 0 ? (
                  records?.map((product, index) => {
                    const fromDates = getDateValues(product?.from_date);
                    const toDates = getDateValues(product?.to_date);
                    const quantity = product?.unitQty;
                    const tableData = fromDates?.map((from, idx) => ({
                      key: idx,
                      startDate: getFromDate(from?.$date?.$numberLong),
                      endDate: getFromDate(toDates?.[idx]?.$date?.$numberLong),
                      quantity: quantity?.[idx] ?? "-",
                    }));
                    const minFromDate =
                      fromDates?.length > 0
                        ? Math.min(
                            ...fromDates?.map((item) =>
                              Number(item?.$date?.$numberLong),
                            ),
                          )
                        : null;

                    const maxToDate =
                      toDates?.length > 0
                        ? Math.max(
                            ...toDates?.map((item) =>
                              Number(item?.$date?.$numberLong),
                            ),
                          )
                        : null;

                    const firstFromDate = minFromDate
                      ? getFromDate(minFromDate)
                      : "";

                    const firstToDate = maxToDate ? getFromDate(maxToDate) : "";
                    const slotsLength = Math.max(
                      fromDates?.length,
                      toDates?.length,
                    );
                    const dateContent = (
                      <>
                        {firstFromDate}
                        <Image
                          src={Arrow3}
                          className="siteName-image"
                          preview={false}
                        />
                        {firstToDate}
                      </>
                    );
                    const popoverContent = (
                      <div className="slots-popover">
                        <div
                          className="product-title"
                          style={{ marginBottom: "10px" }}
                        >
                          Available Slots
                        </div>
                        <Table
                          columns={getTableColumns(product)}
                          dataSource={tableData}
                          pagination={false}
                          rowKey="key"
                          size="small"
                          className="billboard-table"
                        />
                      </div>
                    );
                    return (
                      <div
                        className={
                          "billboard-container" +
                          (product.mandatory_missed_count > 0
                            ? " ribbon-margin"
                            : "")
                        }
                        key={product.siteNo}
                      >
                        {/*  For the feature use case 
                         {product.mandatory_missed_count > 0 && (
                          <Badge.Ribbon
                            text="Action Needed : Complete Details"
                            color="#D2042D"
                          />
                        )} */}
                        <Card className="my-billboard-card" key={index}>
                          <Row className="product-row">
                            <Col lg={2} md={3} className="product-align">
                              <Image
                                className="product-img"
                                src={
                                  product?.image?.[0]
                                    ? product?.insert_type ===
                                      "Bulk_Apparatix_api"
                                      ? product.image[0]
                                      : `${API_BASE_URL_IMAGE}${product.image[0]}`
                                    : ""
                                }
                                preview={false}
                              />
                            </Col>
                            <Col lg={4} style={{ marginRight: "1rem" }}>
                              <Space size={15} direction="vertical">
                                <Row style={{ flexFlow: "column" }}>
                                  <Col span={24}>
                                    <span className="product-copy-text-field">
                                      <Text className="product-labels siteNumber product-title">
                                        {product?.siteNo}
                                      </Text>
                                      <CopyOutlined
                                        onClick={(e) => {
                                          e.stopPropagation(); // prevent tooltip close
                                          handleCopy(product?.siteNo);
                                        }}
                                        className="copy-icon"
                                      />
                                    </span>
                                  </Col>
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={
                                      <pre className="tooltip-product-card">
                                        {product?.title}
                                      </pre>
                                    }
                                  >
                                    <div className="product-copy-text-field">
                                      <span
                                        className="product-title truncate"
                                        strong
                                      >
                                        {String(product?.title).length > 30
                                          ? `${String(
                                              product?.title,
                                            )?.substring(0, 30)}...`
                                          : product?.title}
                                      </span>
                                      <CopyOutlined
                                        onClick={(e) => {
                                          e.stopPropagation(); // prevent tooltip close
                                          handleCopy(product?.title);
                                        }}
                                        className="copy-icon"
                                      />
                                    </div>
                                  </Tooltip>
                                </Row>
                                <Col className="product-labels siteNumber">
                                  City
                                  <Col className="product-title">
                                    {product?.city_name}
                                  </Col>
                                </Col>

                                <Row>
                                  <Col
                                    span={24}
                                    className="product-labels siteNumber"
                                  >
                                    Available
                                  </Col>
                                  <Col
                                    className="product-title truncate"
                                    style={{ display: "block" }}
                                  >
                                    <Tooltip title={dateContent}>
                                      <span>{dateContent}</span>
                                    </Tooltip>
                                  </Col>
                                  <Col
                                    span={24}
                                    className="product-labels siteNumber"
                                  >
                                    {slotsLength > 1 && (
                                      <Popover
                                        content={popoverContent}
                                        trigger="click"
                                        placement="bottom"
                                      >
                                        <span
                                          className="default-color"
                                          style={{
                                            fontFamily: "Roboto",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          View Slots
                                        </span>
                                      </Popover>
                                    )}
                                  </Col>
                                </Row>
                              </Space>
                            </Col>
                            <Col lg={3} md={5}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                }}
                              >
                                <Row>
                                  <Col
                                    span={24}
                                    className="product-labels siteNumber"
                                  >
                                    Address
                                  </Col>
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={product?.address}
                                  >
                                    <Col
                                      className="product-title truncate"
                                      style={{ display: "block" }}
                                    >
                                      {product.address}
                                    </Col>
                                  </Tooltip>
                                </Row>
                                <Row>
                                  <Col
                                    span={24}
                                    className="product-labels siteNumber"
                                  >
                                    Facing Direction
                                  </Col>
                                  <Col
                                    className="product-title"
                                    style={{ display: "block" }}
                                  >
                                    {product.direction}
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={9} md={8} className="product-icons">
                              <Row gutter={[12, 12]}>
                                <Col
                                  md={10}
                                  lg={5}
                                  style={{ textAlign: "center" }}
                                >
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={
                                      <pre className="tooltip-product-card">
                                        Dimensions
                                      </pre>
                                    }
                                  >
                                    <Image
                                      src={DimensionsIcon}
                                      preview={false}
                                      height={28}
                                    />
                                    <div className="billboard-details">
                                      {product?.type?.toLowerCase() ===
                                      "media" ? (
                                        <> {product?.length}</>
                                      ) : (
                                        <>
                                          {formatSize(product?.width)} X{" "}
                                          {formatSize(product?.height)}
                                        </>
                                      )}
                                    </div>
                                  </Tooltip>
                                </Col>
                                <Divider
                                  type="vertical"
                                  style={{
                                    height: "initial",
                                    width: "2px",
                                  }}
                                />
                                <Col
                                  md={10}
                                  lg={6}
                                  style={{ textAlign: "center" }}
                                >
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={
                                      <pre className="tooltip-product-card">
                                        Impressions
                                      </pre>
                                    }
                                  >
                                    <Image src={GraphIcon} preview={false} />
                                    <div className="billboard-details">
                                      {truncatedText(
                                        Number(
                                          product?.secondImpression,
                                        ).toLocaleString(),
                                      )}{" "}
                                      <span>+ per week</span>
                                    </div>
                                  </Tooltip>
                                </Col>
                                <Divider
                                  type="vertical"
                                  style={{ height: "initial" }}
                                />

                                <Col
                                  md={10}
                                  lg={5}
                                  style={{ textAlign: "center" }}
                                >
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={
                                      <pre className="tooltip-product-card">
                                        Product Type
                                      </pre>
                                    }
                                  >
                                    <Image
                                      src={DigitalBoard}
                                      preview={false}
                                      height={28}
                                    />
                                    <div className="billboard-details">
                                      {product.type}
                                    </div>
                                  </Tooltip>
                                </Col>
                                <Divider
                                  type="vertical"
                                  style={{ height: "initial" }}
                                />
                                <Col
                                  md={10}
                                  lg={5}
                                  style={{ textAlign: "center" }}
                                >
                                  <Tooltip
                                    styles={{
                                      body: {
                                        color: "#fff",
                                        backgroundColor: "#000",
                                      },
                                    }}
                                    title={
                                      <pre className="tooltip-product-card">
                                        CPM
                                      </pre>
                                    }
                                  >
                                    CPM
                                    <div className="billboard-details">
                                      {product &&
                                        formatToUSCurrency(
                                          Number(product?.cpm)?.toFixed(2),
                                        )}
                                    </div>
                                  </Tooltip>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={4} md={4}>
                              <Row className="feature-actions">
                                <div className="featured-section">
                                  <Button
                                    type="button"
                                    onClick={() =>
                                      handleFeaturedCampaignModal(product)
                                    }
                                  >
                                    <Image src={FolderIcon} preview={false} />
                                    <span
                                      className="default-color"
                                      style={{ fontFamily: "Roboto" }}
                                    >
                                      Featured in {product.camapigns_count}{" "}
                                      Campaigns{" "}
                                    </span>
                                  </Button>
                                </div>
                                <div>
                                  <span className="map-label">Show on map</span>
                                  <Switch
                                    className="switch-map"
                                    checked={
                                      Number(product.product_visibility) === 1
                                    }
                                    onChange={(checked) =>
                                      handleSwitch(checked, product)
                                    }
                                  />{" "}
                                </div>
                              </Row>
                              <Row className="product-price">
                                <span className="price-details">
                                  $
                                  {Number(
                                    product.default_price,
                                  ).toLocaleString()}
                                </span>
                              </Row>
                              <div className="my-billboard-actions-div">
                                <span
                                  className="action-button"
                                  onClick={() => {
                                    setBillboardText("Edit Product Details");
                                    setSelectedProduct(product);
                                    setOpenDialog(true);
                                  }}
                                >
                                  <EditIcon className="myBillboard-icons" />
                                  Edit
                                </span>
                                <Divider
                                  type="vertical"
                                  className="my-billboard-divider"
                                />

                                <span
                                  className="action-button"
                                  onClick={() => {
                                    setSelectedProduct(product);
                                    setOpenDialog(true);
                                    setBillboardText(
                                      "Duplicate Product Details",
                                    );
                                    setIsCloneProduct(true);
                                  }}
                                >
                                  <DocumentIcon className="myBillboard-icons" />
                                  Duplicate
                                </span>

                                <Divider
                                  type="vertical"
                                  className="my-billboard-divider"
                                />

                                <span
                                  className="action-button delete-button"
                                  onClick={() => {
                                    dispatch(setIsProductPopUp(true));
                                    setSelectedProduct(product);
                                  }}
                                >
                                  <EyeIcon className="myBillboard-icons" />
                                  View
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <EmptyViewCard
                      header={"Products..."}
                      text={
                        "Looks like there aren't any products right now. But don't worry—add new product! Stay tuned and keep your listings"
                      }
                    />
                  </div>
                )}
                <div className="pagination">
                  <Pagination
                    current={currentPage}
                    pageSize={itemsPerPage}
                    total={
                      isNaN(Number(page_count)) ? 0 : Number(page_count) * 15
                    }
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </Row>
            )}
          </>
        </div>
      )}

      {!mobileOpenDialog && (
        <Modal
          className="billboard-dialog"
          title={billBoardText}
          centered
          open={openDialog}
          maskClosable={false}
          onOk={() => {
            setOpenDialog(false);
          }}
          destroyOnClose={true}
          onCancel={() => {
            if (productsLoader) return;
            dispatch(RESET_PRODUCT());
            form.resetFields();
            setSelectedProduct(null);
            setOpenDialog(false);
            setIsCloneProduct(false);
          }}
          footer={null}
          style={{ width: "90%" }}
          width={{
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "60%",
            xl: "50%",
            xxl: "40%",
          }}
        >
          <Divider />
          <AddBillBoard
            upfrontAmount={user?.upfront_amount}
            key={selectedProduct?.id ?? "new-billboard"}
            form={form}
            productDetails={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            setCurrentPage={setCurrentPage}
            id={selectedProduct?.id}
            isClone={isCloneProduct}
            setIsCloneProduct={setIsCloneProduct}
            openDialog={openDialog}
            setOpenDialog={(value) => {
              setOpenDialog(value);
              refreshContentProducts();
            }}
            billBoardText={billBoardText}
          />
        </Modal>
      )}
      {mobileOpenDialog && (
        <>
          {isMobile && (
            <div className="my-billboard-back-arrow">
              <BackArrow
                onClick={() => {
                  if (productsLoader) return;
                  dispatch(RESET_PRODUCT());
                  form.resetFields();
                  setSelectedProduct(null);
                  setMobileOpenDialog(false);
                  setIsCloneProduct(false);
                }}
              />
              <span className="campaign  my-campaign">{billBoardText}</span>
            </div>
          )}
          <AddBillBoard
            key={selectedProduct?.id ?? "new-billboard"}
            id={selectedProduct?.id}
            form={form}
            isClone={isCloneProduct}
            setCurrentPage={setCurrentPage}
            setIsCloneProduct={setIsCloneProduct}
            setSelectedProduct={setSelectedProduct}
            mobileOpenDialog={mobileOpenDialog}
            setMobileOpenDialog={(value) => {
              setMobileOpenDialog(value);
              refreshContentProducts();
            }}
          />
        </>
      )}

      <Modal
        className="billboard-dialog"
        centered
        open={openTransferDialog}
        onOk={() => setTransferDialog(false)}
        maskClosable={false}
        destroyOnClose={true}
        key={openTransferDialog}
        onCancel={() => {
          if (productsLoader) return;
          setTransferDialog(false);
        }}
        footer={null}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "40%",
        }}
      >
        <TransferProducts
          openTransferDialog={openTransferDialog}
          setCurrentPage={setCurrentPage}
          setTransferDialog={(value) => {
            setTransferDialog(value);
            refreshContentProducts();
          }}
        />
      </Modal>

      <ProductModalPopUp
        selectedTab={"recommonded"}
        contentName={"View Product"}
        productId={selectedProduct?.id}
        setSelectedProduct={setSelectedProduct}
        isBillBoard={true}
      />

      {isModalOpen && (
        <FeaturedCampaignsModal
          featureModal={isModalOpen}
          setFeatureModal={setIsModalOpen}
          productDetails={productDetails}
        ></FeaturedCampaignsModal>
      )}
      {bulkUpload && (
        <BulkUploadModal
          bulkUpload={bulkUpload}
          setBulkUpload={setBulkUpload}
        ></BulkUploadModal>
      )}
      {sellerCampainsLoader && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default MyBillboard;
